<template>
  <!-- xls, xlsx, doc, docx 中转页 -->
  <div class="content" v-if="$tools.isWeiXin()">
    <img class="img1" src="@/static/images/material/T1.png" alt />
    <img class="img2" src="@/static/images/material/T2.png" alt />
    <div class="desc">暂不支持在微信打开</div>
    <div class="desc">请在浏览器打开访问</div>
  </div>
</template>
<script>
export default {
  data: () => ({
    index: "",
    id: "",
    coursewareList: [],
    fileId: "" // 是否有文件id，有就是单个文件，没有的是课件列表里的文件
  }),
  components: {},
  created() {
    
    if (!this.$tools.isWeiXin()) {
      // 有文件id用文件流打开
      if (this.$route.query.fileId) {
        this.fileId = this.$route.query.fileId;
        // let base = "https://fqyf.wts9999.net";
        // if (this.$config.env == 1) {
        //   base = "https://www.fxyf99.com";
        // }
        const url = `/api/site/getFileById?fileId=${this.fileId}`;
        location.href = url;
      } else if(this.$route.query.id) {
        //没有文件id的，用url打开
        this.index = this.$route.query.index;
        this.id = this.$route.query.id;
        this.download();
      } else if(this.$route.query.url) {
        location.href = this.$route.query.url;
      }
    }
  },
  methods: {
    // 获取课件列表
    download() {
      this.$http({
        url: "/app/information/queryCoursewareList",
        type: "GET",
        data: {
          articleId: this.id
        }
      })
        .then(res => {
          this.coursewareList = res.data;
          location.href = this.coursewareList[this.index].url;
        })
        .catch(e => {});
    }
  }
};
</script>
<style lang='scss' scoped>
.content {
  display: flex;
  flex-direction: column;
  align-items: center;

  .img1 {
    width: 100%;
  }
  .img2 {
    margin-top: 230px;
    width: 372px;
    height: 310px;
  }
  .desc {
    text-align: center;
    font-size: 30px;
    font-weight: 400;
    line-height: 50px;
    color: #888888;
  }
}
</style>
